import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ResetPasswordFormPage from '../components/account/ResetPasswordFormPage';

const ResetPasswordPage = () => {
  const location = useLocation();
  const token = useMemo(
    () => new URLSearchParams(location.search).get('reset_password_token'),
    [location.search]
  );
  return <ResetPasswordFormPage token={token} />;
};

export default ResetPasswordPage;
